/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ClientCreatedResponseDto,
  ClientResponseDto,
  ClientUserResponseDto,
  CreateClientDto,
  MessageResponseDto,
  UpdateClientDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get all clients in the organization that the user has access to
 * @summary List organization clients
 */
export const organizationClientsControllerFindAll = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ClientResponseDto[]>(
    { url: `/api/organizations/${orgId}/clients`, method: 'GET', signal },
    options
  );
};

export const getOrganizationClientsControllerFindAllQueryKey = (orgId?: string) => {
  return [`/api/organizations/${orgId}/clients`] as const;
};

export const getOrganizationClientsControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOrganizationClientsControllerFindAllQueryKey(orgId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organizationClientsControllerFindAll>>
  > = ({ signal }) => organizationClientsControllerFindAll(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationClientsControllerFindAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerFindAll>>
>;
export type OrganizationClientsControllerFindAllQueryError = void;

export function useOrganizationClientsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof organizationClientsControllerFindAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationClientsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof organizationClientsControllerFindAll>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationClientsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List organization clients
 */

export function useOrganizationClientsControllerFindAll<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
  TError = void,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOrganizationClientsControllerFindAllQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new client in the organization (owner only)
 * @summary Create a new client
 */
export const organizationClientsControllerCreate = (
  orgId: string,
  createClientDto: CreateClientDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ClientCreatedResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createClientDto,
      signal,
    },
    options
  );
};

export const getOrganizationClientsControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationClientsControllerCreate>>,
    TError,
    { orgId: string; data: CreateClientDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationClientsControllerCreate>>,
  TError,
  { orgId: string; data: CreateClientDto },
  TContext
> => {
  const mutationKey = ['organizationClientsControllerCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationClientsControllerCreate>>,
    { orgId: string; data: CreateClientDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return organizationClientsControllerCreate(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationClientsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerCreate>>
>;
export type OrganizationClientsControllerCreateMutationBody = CreateClientDto;
export type OrganizationClientsControllerCreateMutationError = void;

/**
 * @summary Create a new client
 */
export const useOrganizationClientsControllerCreate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationClientsControllerCreate>>,
      TError,
      { orgId: string; data: CreateClientDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationClientsControllerCreate>>,
  TError,
  { orgId: string; data: CreateClientDto },
  TContext
> => {
  const mutationOptions = getOrganizationClientsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get details of a specific client
 * @summary Get client by ID
 */
export const organizationClientsControllerFindOne = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ClientResponseDto>(
    { url: `/api/organizations/${orgId}/clients/${clientId}`, method: 'GET', signal },
    options
  );
};

export const getOrganizationClientsControllerFindOneQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [`/api/organizations/${orgId}/clients/${clientId}`] as const;
};

export const getOrganizationClientsControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOrganizationClientsControllerFindOneQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organizationClientsControllerFindOne>>
  > = ({ signal }) => organizationClientsControllerFindOne(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationClientsControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerFindOne>>
>;
export type OrganizationClientsControllerFindOneQueryError = void;

export function useOrganizationClientsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof organizationClientsControllerFindOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationClientsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof organizationClientsControllerFindOne>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationClientsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get client by ID
 */

export function useOrganizationClientsControllerFindOne<
  TData = Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerFindOne>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOrganizationClientsControllerFindOneQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update client details (owner only)
 * @summary Update a client
 */
export const organizationClientsControllerUpdate = (
  orgId: string,
  clientId: string,
  updateClientDto: UpdateClientDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<ClientResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateClientDto,
    },
    options
  );
};

export const getOrganizationClientsControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationClientsControllerUpdate>>,
    TError,
    { orgId: string; clientId: string; data: UpdateClientDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationClientsControllerUpdate>>,
  TError,
  { orgId: string; clientId: string; data: UpdateClientDto },
  TContext
> => {
  const mutationKey = ['organizationClientsControllerUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationClientsControllerUpdate>>,
    { orgId: string; clientId: string; data: UpdateClientDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return organizationClientsControllerUpdate(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationClientsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerUpdate>>
>;
export type OrganizationClientsControllerUpdateMutationBody = UpdateClientDto;
export type OrganizationClientsControllerUpdateMutationError = void;

/**
 * @summary Update a client
 */
export const useOrganizationClientsControllerUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationClientsControllerUpdate>>,
      TError,
      { orgId: string; clientId: string; data: UpdateClientDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationClientsControllerUpdate>>,
  TError,
  { orgId: string; clientId: string; data: UpdateClientDto },
  TContext
> => {
  const mutationOptions = getOrganizationClientsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a client and all related data (owner only). Cannot delete the last client.
 * @summary Delete a client
 */
export const organizationClientsControllerRemove = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/organizations/${orgId}/clients/${clientId}`, method: 'DELETE' },
    options
  );
};

export const getOrganizationClientsControllerRemoveMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationClientsControllerRemove>>,
    TError,
    { orgId: string; clientId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationClientsControllerRemove>>,
  TError,
  { orgId: string; clientId: string },
  TContext
> => {
  const mutationKey = ['organizationClientsControllerRemove'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationClientsControllerRemove>>,
    { orgId: string; clientId: string }
  > = (props) => {
    const { orgId, clientId } = props ?? {};

    return organizationClientsControllerRemove(orgId, clientId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationClientsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerRemove>>
>;

export type OrganizationClientsControllerRemoveMutationError = void;

/**
 * @summary Delete a client
 */
export const useOrganizationClientsControllerRemove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationClientsControllerRemove>>,
      TError,
      { orgId: string; clientId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationClientsControllerRemove>>,
  TError,
  { orgId: string; clientId: string },
  TContext
> => {
  const mutationOptions = getOrganizationClientsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get all users who have access to a specific client
 * @summary Get users with access to client
 */
export const organizationClientsControllerGetClientUsers = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ClientUserResponseDto[]>(
    { url: `/api/organizations/${orgId}/clients/${clientId}/users`, method: 'GET', signal },
    options
  );
};

export const getOrganizationClientsControllerGetClientUsersQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [`/api/organizations/${orgId}/clients/${clientId}/users`] as const;
};

export const getOrganizationClientsControllerGetClientUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getOrganizationClientsControllerGetClientUsersQueryKey(orgId, clientId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>
  > = ({ signal }) =>
    organizationClientsControllerGetClientUsers(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OrganizationClientsControllerGetClientUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>
>;
export type OrganizationClientsControllerGetClientUsersQueryError = void;

export function useOrganizationClientsControllerGetClientUsers<
  TData = Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
          TError,
          Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationClientsControllerGetClientUsers<
  TData = Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
          TError,
          Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useOrganizationClientsControllerGetClientUsers<
  TData = Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get users with access to client
 */

export function useOrganizationClientsControllerGetClientUsers<
  TData = Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organizationClientsControllerGetClientUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getOrganizationClientsControllerGetClientUsersQueryOptions(
    orgId,
    clientId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Grant a user access to a specific client (owner only)
 * @summary Add user to client
 */
export const organizationClientsControllerAddUserToClient = (
  orgId: string,
  clientId: string,
  userId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    {
      url: `/api/organizations/${orgId}/clients/${clientId}/users/${userId}`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getOrganizationClientsControllerAddUserToClientMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationClientsControllerAddUserToClient>>,
    TError,
    { orgId: string; clientId: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationClientsControllerAddUserToClient>>,
  TError,
  { orgId: string; clientId: string; userId: string },
  TContext
> => {
  const mutationKey = ['organizationClientsControllerAddUserToClient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationClientsControllerAddUserToClient>>,
    { orgId: string; clientId: string; userId: string }
  > = (props) => {
    const { orgId, clientId, userId } = props ?? {};

    return organizationClientsControllerAddUserToClient(orgId, clientId, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationClientsControllerAddUserToClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerAddUserToClient>>
>;

export type OrganizationClientsControllerAddUserToClientMutationError = void;

/**
 * @summary Add user to client
 */
export const useOrganizationClientsControllerAddUserToClient = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationClientsControllerAddUserToClient>>,
      TError,
      { orgId: string; clientId: string; userId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationClientsControllerAddUserToClient>>,
  TError,
  { orgId: string; clientId: string; userId: string },
  TContext
> => {
  const mutationOptions = getOrganizationClientsControllerAddUserToClientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove a user's access to a specific client (owner only)
 * @summary Remove user from client
 */
export const organizationClientsControllerRemoveUserFromClient = (
  orgId: string,
  clientId: string,
  userId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/organizations/${orgId}/clients/${clientId}/users/${userId}`, method: 'DELETE' },
    options
  );
};

export const getOrganizationClientsControllerRemoveUserFromClientMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof organizationClientsControllerRemoveUserFromClient>>,
    TError,
    { orgId: string; clientId: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof organizationClientsControllerRemoveUserFromClient>>,
  TError,
  { orgId: string; clientId: string; userId: string },
  TContext
> => {
  const mutationKey = ['organizationClientsControllerRemoveUserFromClient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof organizationClientsControllerRemoveUserFromClient>>,
    { orgId: string; clientId: string; userId: string }
  > = (props) => {
    const { orgId, clientId, userId } = props ?? {};

    return organizationClientsControllerRemoveUserFromClient(
      orgId,
      clientId,
      userId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type OrganizationClientsControllerRemoveUserFromClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof organizationClientsControllerRemoveUserFromClient>>
>;

export type OrganizationClientsControllerRemoveUserFromClientMutationError = void;

/**
 * @summary Remove user from client
 */
export const useOrganizationClientsControllerRemoveUserFromClient = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof organizationClientsControllerRemoveUserFromClient>>,
      TError,
      { orgId: string; clientId: string; userId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof organizationClientsControllerRemoveUserFromClient>>,
  TError,
  { orgId: string; clientId: string; userId: string },
  TContext
> => {
  const mutationOptions =
    getOrganizationClientsControllerRemoveUserFromClientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
